import { C } from '../../../common';

const { MAX_PAGE_PRELOAD } = C;

export default ({ pages = [] } = {}) => (
  pages.map(({ background = {} }, index) => ({
    index,
    // @TODO: We should wait for video to.
    // loaded: index > 4 || (!background.image && !background.video && !(type === CONTENT && image)),
    loaded: index > MAX_PAGE_PRELOAD || !background.image,
    viewed: index === 0,
    visibility: index === 0 ? 1 : 0,
  }))
);
